import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FooterService {

  private isHiddenFooterMenu: boolean = false;

  get isHiddenFooter(): boolean {
    return this.isHiddenFooterMenu;
  }

  set isHiddenFooter(value: boolean) {
    this.isHiddenFooterMenu = value;
  }

  /**
   * Method: change value hideFooterMenu
   * @param show
   */
  changeHideFooterMenu(show: boolean): void {
    this.isHiddenFooter = show;
  }

}
